import { cx } from "@linaria/core";
import { useRef } from "react";

import { SliderComponentSelector } from "../organism.slider/_slider";

import * as styles from "./_carousel.style";
import { Slide } from "./atom.slide";
import { SliderModel } from "@courses-pm2/api";
import { CircularButton, Slider, usePagination } from "@pm2/compat";

type Props = {
  model: SliderModel;
  displayCaption: boolean;
};

export function CarouselSlider(props: Props): React.JSX.Element | null {
  const sliderRef = useRef<HTMLDivElement>(null);
  const pagination = usePagination(props.model.slides, {
    sliderRef,
    infinite: true,
    type: "pages",
  });

  const desiredItemsPerPage = Math.min(
    props.model.carouselCount ?? 3,
    props.model.slides.length,
  );

  return (
    <section
      className={cx("gSlider", styles.wrapper)}
      data-component-type={SliderComponentSelector}
    >
      {props.model.slides.length > pagination.itemsPerPage && (
        <div className={styles.navigationButton} data-direction="backwards">
          <CircularButton onClick={pagination.goBackwards} inversed />
        </div>
      )}

      <div
        className={styles.slider}
        style={styles.tokens.itemsPerPage.__override(desiredItemsPerPage)}
        data-desired-count={desiredItemsPerPage}
      >
        <Slider
          wrapperRef={sliderRef}
          pagination={pagination}
          items={props.model.slides}
          infinite
        >
          {(item, { isVisible }) => (
            <Slide isVisible={isVisible} model={item} />
          )}
        </Slider>
      </div>

      {props.model.slides.length > pagination.itemsPerPage && (
        <div className={styles.navigationButton} data-direction="forwards">
          <CircularButton onClick={pagination.goForwards} />
        </div>
      )}
    </section>
  );
}
